import { render } from "./SendForm.vue?vue&type=template&id=d89854b4"
import script from "./SendForm.vue?vue&type=script&lang=js"
export * from "./SendForm.vue?vue&type=script&lang=js"

import "./SendForm.vue?vue&type=style&index=0&id=d89854b4&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__